import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Link from 'flarum/common/components/Link';

/**
 * Returns a setting added by the extension
 */
function setting(slug, cast) {
  let setting = app.forum.attribute("maicol07-sso.".concat(slug));
  if (cast !== undefined) {
    if (cast === Boolean && !isNaN(setting)) {
      setting = Number(setting);
    }
    return cast(setting);
  }
  return setting;
}

/**
 * Returns login and signup props
 */
function getItems() {
  return {
    login: {
      url: setting('login_url'),
      itemName: 'logIn',
      removeItem: setting('remove_login_btn', Boolean),
      text: app.translator.trans('core.forum.header.log_in_link')
    },
    signup: {
      url: setting('signup_url'),
      itemName: 'signUp',
      removeItem: setting('remove_signup_btn', Boolean),
      text: app.translator.trans('core.forum.header.sign_up_link')
    }
  };
}
app.initializers.add('maicol07-sso', () => {
  override('flarum/forum/components/LogInModal', 'oncreate', () => {
    if (!setting('provider_mode', Boolean)) {
      const loginUrl = setting('login_url');
      if (loginUrl) {
        window.location.href = loginUrl;
      } else {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('maicol07-sso.forum.no_login_url_error'));
      }
      throw new Error('Stop execution');
    }
  });
  extend(HeaderSecondary.prototype, 'items', buttons => {
    if (!setting('provider_mode', Boolean)) {
      const items = getItems();
      for (const _ref of Object.entries(items)) {
        var _ref2 = _slicedToArray(_ref, 2);
        const props = _ref2[1];
        if (props.url) {
          if (props.removeItem) {
            buttons.remove(props.itemName);
          } else {
            // Remove login button
            if (!buttons.has(props.itemName)) {
              return;
            }
            buttons.setContent(props.itemName, m("a", {
              href: props.url,
              className: "Button Button--link"
            }, props.text));
          }
        }
      }
    }
  });
  extend('flarum/forum/components/SettingsPage', 'accountItems', items => {
    if (setting('provider_mode', Boolean) || !setting('login_url')) {
      return; // Do not add account items if no login url is set.
    }

    // Remove change email and password buttons
    items.remove('changeEmail');
    items.remove('changePassword');
    if (!setting('manage_account_url', Boolean)) {
      return;
    }
    items.add('manageAccount', m(Link, {
      class: "Button",
      external: true,
      href: setting('manage_account_url'),
      target: setting('manage_account_btn_open_in_new_tab', Boolean) ? '_blank' : ''
    }, app.translator.trans('maicol07-sso.forum.manage_account_btn')));
  });
  extend('flarum/forum/components/SettingsPage', 'settingsItems', items => {
    if (setting('manage_account_url', Boolean) || setting('provider_mode', Boolean)) {
      return; // Manage account link is added above
    }

    // Remove account section
    if (items.has('account') && items.get('account').children.length === 0) {
      items.remove('account');
    }
  });
});